import { Link } from "react-router-dom";
import { Mail, Heart } from "lucide-react";
import kopfaiLogoDark from "@/assets/kopfai-blog-logo-dark.svg";
export const Footer = () => {
  return (
    <footer className="bg-kopf-primary text-white mt-auto">
      <div className="container mx-auto px-4 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <img src={kopfaiLogoDark} alt="KopfAI Blog" className="h-6 w-auto" />
            <p className="text-white/80 text-sm">Artigos sobre bem-estar mental e clareza emocional.</p>
          </div>

          {/* Navigation Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Navegação</h3>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm">
                Início
              </Link>
              <Link to="/sobre" className="text-white/80 hover:text-white transition-colors text-sm">
                Sobre
              </Link>
              <a href="https://kopfai.com/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors text-sm">
                Conhecer a KopfAi
              </a>
            </nav>
          </div>

          {/* Contact Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contato</h3>
            <a
              href="mailto:contato@kopfai.com"
              className="flex items-center gap-2 text-white/80 hover:text-white transition-colors text-sm"
            >
              <Mail className="w-4 h-4" />
              contato@kopfai.com
            </a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} KopfAI Blog. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-2 text-white/60 text-sm">
            <span>Feito com</span>
            <Heart className="w-4 h-4 text-kopf-accent fill-kopf-accent" />
            <span>para seu bem-estar</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
